import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  ActivatedRoute,
  RouterStateSnapshot,
  CanActivate,
  CanActivateChild,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'app/core/security/auth/auth.service';

@Injectable()
export class AppAuthGuardService implements CanActivate, CanActivateChild {
  constructor(private auth: AuthService, private route: ActivatedRoute, private router: Router) {}

  // Synchronous guard
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url: string = state.url;

    if (route.children.length > 0) {
      const anonymousCheckRoute = route.children[0].children[0];
      if (anonymousCheckRoute && anonymousCheckRoute.data && anonymousCheckRoute.data.allowAnonymous && anonymousCheckRoute.data.allowAnonymous === true) {
        return true;
      }
    }

    return this.checkLogin(url);
  }

  // Synchronous child guard
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  private checkLogin(url: string): boolean {
    if (this.auth.isLoggedIn()) {
      console.debug('already logged in');
      return true;
    }

    console.debug('setting redirect url from auth guard');
    console.debug(url);
    this.auth.setRedirectUrl(url);

    this.router.navigate(['/login']);
    return true;
  }
}
